import { render, staticRenderFns } from "./DemocraticAutonomy.vue?vue&type=template&id=07579de3&scoped=true&"
import script from "./DemocraticAutonomy.vue?vue&type=script&lang=js&"
export * from "./DemocraticAutonomy.vue?vue&type=script&lang=js&"
import style0 from "./DemocraticAutonomy.vue?vue&type=style&index=0&id=07579de3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07579de3",
  null
  
)

export default component.exports